
<!-- Todo: #MAWX3244: Doesn't look like anything under !isSdfCardFlow is ever used. Probably can remove this -->
<div
  *ngIf="!isSdfCardFlow"
  class="mgo-location-search-result"
  [ngClass]="{ 'hide-result': hideResult }"
>
  <ng-container *ngIf="!searchResults && geolocationService.errorCode">
    <ng-container [ngSwitch]="geolocationService.errorCode">
      <h3 *ngSwitchCase="2" class="no-results">
        {{ locationLabels?.unableToLocation }}
      </h3>
      <h3 *ngSwitchCase="3" class="no-results">
        {{ locationLabels?.typeNewAddress }}
      </h3>
    </ng-container>
  </ng-container>
  <div *ngFor="let result of searchResults; index as i" class="row-result">
    <div class="mgo-circle content">{{ i + 1 }}</div>
    <div class="row-spacing">
      <div class="row-result">
        <p class="text-business-name">
          {{ result?.locationDetails?.name }}
        </p>
        <p class="text-mile">{{ getDistance(result.locationDetails) }}</p>
      </div>
      <p class="text-address">
        {{
          locationFinderService.getFormattedAddress({
            addressLine1: result?.locationDetails?.addressLine1,
            addressLine2: result?.locationDetails?.addressLine2,
            addressLine3: result?.locationDetails?.addressLine3
          })
        }}<br />
        {{
          locationFinderService.getFormattedAddress({
            city: result?.locationDetails?.city,
            state: result?.locationDetails?.state,
            zipCode: result?.locationDetails?.zipCode,
            postalCode: result?.locationDetails?.postalCode
          })
        }}
      </p>

      <p *ngIf="result?.locationDetails?.agentURL" class="text-business-name">
        <a
          *ngIf="result?.locationDetails?.country === 'GB'"
          target="_blank"
          href="{{ result?.locationDetails?.agentURL }}"
          ><span class="icon-center">
            {{ locationLabels?.agentURLTextUK }}</span
          >
          <i class="material-icons mgo-show-cursor icon-center">open_in_new</i>
        </a>
        <a
          *ngIf="result?.locationDetails?.country === 'FI'"
          target="_blank"
          href="{{ result?.locationDetails?.agentURL }}"
          ><span class="icon-center">
            {{ locationLabels?.agentURLTextFinland }}</span
          >
          <i class="material-icons mgo-show-cursor icon-center"
            >open_in_new</i
          ></a
        >
      </p>
      <div>
        <ng-container>
          <app-location-services
            [labels]="labels"
            [locationServices]="result?.locationServices"
          ></app-location-services>
        </ng-container>
        <ng-container>
          <app-location-closing-hour
            [labels]="labels"
            [businessHours]="result.locationOperatingHours"
          ></app-location-closing-hour>
        </ng-container>
        <ng-container>
          <div
            class="label-bank-acct-m-bot"
            *ngIf="result?.locationDetails?.bankAccountRequired"
          >
            <app-alert color="info" icon="circle-info">{{
              locationLabels?.bankAccountRequired
            }}</app-alert>
          </div>
        </ng-container>
        <ng-container *ngIf="flow === 'deposit'">
          <div class="btn-container">
            <button
              color="primary"
              mat-raised-button
              (click)="selectLocator(result, i)"
              [disabled]="
                result.locationDetails.locationId &&
                locationFinderService.getUnavailable(
                  result.locationDetails.locationId
                )
              "
            >
              {{ locationLabels?.selectLocationBtnTxt }}
            </button>
          </div>
          <div
            *ngIf="
              result.locationDetails.locationId &&
              locationFinderService.getUnavailable(
                result.locationDetails.locationId
              )
            "
          >
            <p class="theme-color-error">
              {{
                locationFinderService.getUnavailable(
                  result.locationDetails.locationId
                )
              }}
            </p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="isSdfCardFlow">
  <div class="result-wrapper" *ngIf="searchResults">
    <ng-container *ngIf="!searchResults && geolocationService.errorCode">
      <ng-container [ngSwitch]="geolocationService.errorCode">
        <p *ngSwitchCase="2" class="no-results">
          {{ locationLabels?.unableToLocation }}
        </p>
        <p *ngSwitchCase="3" class="no-results">
          {{ locationLabels?.typeNewAddress }}
        </p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="(isTabletOrMobile$ | async) === false">
      <ng-container *ngFor="let result of searchResults; index as i">
        <div
          class="location-cards-contanier"
          [class.selected-card]="selectedLocationIndex === i"
        >
          <div class="store-info-address-index">
            <div
              class="index selected-idx"
              [ngClass]="{ 'selected-idx': selectedLocationIndex === i }"
            >
              {{ i + 1 }}
            </div>
            <div class="information">
              <div class="name-distance">
                <div class="location-name">
                  {{
                    locationFinderService.extractLocationName(
                      result?.locationDetails?.name!
                    )
                  }}
                </div>
                <div class="location-distance">
                  {{ getDistance(result.locationDetails).toLowerCase() }}
                </div>
              </div>
              <div class="location-address">
                {{
                  locationFinderService.getFormattedAddress({
                    addressLine1: result?.locationDetails?.addressLine1,
                    addressLine2: result?.locationDetails?.addressLine2,
                    addressLine3: result?.locationDetails?.addressLine3
                  })
                }},
                {{
                  locationFinderService.getFormattedAddress({
                    city: result?.locationDetails?.city,
                    state: result?.locationDetails?.state,
                    zipCode: result?.locationDetails?.zipCode,
                    postalCode: result?.locationDetails?.postalCode
                  })
                }}
              </div>
              <div class="location-phonenumber">
                {{ result?.locationPhone?.phone }}
              </div>
              <div class="openHours-locator-selectBtn-container">
                <div class="openhours">
                  <app-location-closing-hour
                    [labels]="labels"
                    [businessHours]="result.locationOperatingHours"
                  ></app-location-closing-hour>
                  <img
                    [src]="
                      isSelectedIndex(i)
                        ? 'assets/images/map-location/chevron-up-icon.svg'
                        : 'assets/images/arr.chevron.down.small.svg'
                    "
                    [alt]="isSelectedIndex(i) ? 'chevron-up' : 'chevron-down'"
                    (click)="toggleStoreHours(i)"
                  />
                </div>
                <ng-container *ngIf=
                "flow === 'deposit'">
                  <div class="select-location">
                    <button
                      type="button"
                      [ngClass]="{
                        'selected-state': isLocationMarkerSelected === false ? false : selectedLocationIndex === i
                      }"
                      class="selectLocationbtn"
                      (click)="selectLocator(result, i)"
                      [disabled]="isLocationMarkerSelected === false ? false : selectedLocationIndex === i"
                    >
                      <span
                        class="select-location-text"
                        [ngClass]="{
                          'selected-state': isLocationMarkerSelected === false ? false : selectedLocationIndex === i
                        }"
                      >
                        {{
                          locationLabels?.selectLocationBtnTxt
                            .charAt(0)
                            .toUpperCase() +
                            locationLabels?.selectLocationBtnTxt
                              .slice(1)
                              .toLowerCase()
                        }}
                      </span>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <ng-container *ngIf="expandLocationCard && isSelectedIndex(i)">
            <div class="store-and-service-view">
              <button
                class="store active"
                (click)="switchStoreServiceViw('store')"
                [ngClass]="{ active: isStoreActive }"
              >
                <span
                  class="store-label active"
                  [ngClass]="{ active: isStoreActive }"
                  >{{
                    sdfCardLabels?.locationMaps?.storeDetails?.store || "Store"
                  }}</span
                >
              </button>
              <button
                class="services active"
                (click)="switchStoreServiceViw('services')"
                [ngClass]="{ active: isServiceActive }"
              >
                <span
                  class="services-label active"
                  [ngClass]="{ active: isServiceActive }"
                >
                  {{
                    sdfCardLabels?.locationMaps?.storeDetails?.services ||
                      "Services"
                  }}
                </span>
              </button>
            </div>
            <div class="before-you-go-container">
              <div class="befor-you-go-header-wrapper">
                <div class="label-text">
                  {{
                    sdfCardLabels?.locationMaps?.storeDetails?.beforeYouGo ||
                      "Before you go..."
                  }}
                </div>
              </div>
              <div class="before-content-container">
                <!-- <div class="dynamic-content">
                  <div class="icon-wrapper">
                    <img
                      src="assets\images\map-location\image-portriat-icon.svg"
                      alt="portrait"
                    />
                  </div>
                  <div class="dynamic-related-text">
                    {{
                      "[Dynamic text] Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                    }}
                  </div>
                </div> -->
                <div class="cash-related-services">
                  <div class="icon-wrapper">
                    <img
                      src="assets\images\map-location\currency-icon.svg"
                      alt="currency"
                    />
                  </div>
                  <div class="cash-related-text">
                    {{
                      sdfCardLabels?.locationMaps?.storeDetails?.cashOnly ||
                        "You can only use cash for cash-related services at this location."
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="divider"></div>

            <div class="slider-container">
              <div
                class="store-slider-content"
                [@slideStore]="isStoreActive ? 'active' : 'inactive'"
                (@slideStore.done)="onStoreAnimationDone($event)"
              >
                <div class="toggle-lable-icon-container">
                  <div
                    class="label-text"
                    *ngIf="showStoreHours; else hideStoreHours"
                  >
                    {{
                      sdfCardLabels?.locationMaps?.storeDetails
                        ?.showStoreHours || "Show store hours"
                    }}
                  </div>
                  <ng-template #hideStoreHours>
                    <div class="label-text">
                      {{
                        sdfCardLabels?.locationMaps?.storeDetails
                          ?.hideStoreHours || "Hide store hours"
                      }}
                    </div>
                  </ng-template>
                  <div class="icon-wrapper" (click)="toggleHideStoreHours()">
                    <img
                      [ngClass]="
                        !showStoreHours ? 'chevron-up' : 'chevron-down'
                      "
                      src="assets\images\map-location\expand-store-chevron-blue.svg"
                      alt="chevron"
                    />
                  </div>
                </div>
                <div
                  class="store-operations"
                  [@expandCollapse]="showStoreHours ? 'collapsed' : 'expanded'"
                >
                  <div
                    class="store-hours-details"
                    *ngFor="let day of daysOfWeek; let weLocationDetails = index "
                  >
                    <div class="date-hours">
                      <div
                        class="date"
                        [ngClass]="{
                          'current-day-color': todayDay === weLocationDetails + 1
                        }"
                      >
                        {{ locationLabels[day] }}
                      </div>
                      <div
                        class="hours"
                        [ngClass]="{
                          'current-day-color': todayDay === weLocationDetails + 1
                        }"
                      >
                        {{ 
                          isLocationClosedAllDay(result.locationOperatingHours[day]) ? 
                          locationLabels?.closedTxt || "Closed" : 
                          result.locationOperatingHours[day] 
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="specific-hours-wrapper">
                    <div class="specific-hours-content">
                      {{
                        sdfCardLabels?.locationMaps?.storeDetails
                          ?.specificLocationHours ||
                          "Specific hours of operation may vary. Please contact the location for more information."
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="services-slide-content"
                [@slideService]="isServiceActive ? 'active' : 'inactive'"
              >
                <app-location-services
                  [labels]="labels"
                  [locationServices]="result?.locationServices"
                ></app-location-services>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="divider"></div>
      </ng-container>
    </ng-container>
    <!-- Mobile or table view -->
    <ng-container *ngIf="isTabletOrMobile$ | async">
      <ng-container *ngFor="let result of searchResults; index as i">
        <div
          [@slideInOutAnimation]="isMobileCardExpanded ? 'in' : 'out'"
          class="tablet-or-mobile-card-container"
          [ngClass]="{
            'top-layer': isMobileCardExpanded && result.locationDetails.locationId === singleLocationToview?.locationDetails.locationId,
            'cardExpanded': isMobileCardExpanded
          }"
        >
          <ng-container *ngIf="!isMobileCardExpanded">
            <div class="collapse-view" (click)="expandMobileCard(true, result)">
              <div class="storename-and-distance">
                <div class="storename">
                  {{
                    locationFinderService.extractLocationName(
                      result?.locationDetails?.name!
                    )
                  }}
                </div>
                <div class="distance">
                  {{ getDistance(result.locationDetails).toLowerCase() }}
                </div>
              </div>
              <div class="address-and-store-operations">
                <div class="address-icon">
                  <div class="icon">
                    <img
                      src="assets\images\map-location\icon-tag.svg"
                      alt="location-icon"
                    />
                  </div>
                  <div class="address">
                    {{
                      locationFinderService.getFormattedAddress({
                        addressLine1: result?.locationDetails?.addressLine1,
                        addressLine2: result?.locationDetails?.addressLine2,
                        addressLine3: result?.locationDetails?.addressLine3
                      })
                    }}
                    {{
                      locationFinderService.getFormattedAddress({
                        city: result?.locationDetails?.city,
                        state: result?.locationDetails?.state
                      })
                    }}
                  </div>
                </div>
                <div class="store-operations-icon">
                  <div class="icon">
                    <img
                      src="assets\images\map-location\clock.svg"
                      alt="clock"
                    />
                  </div>
                  <div class="store-operations">
                    <app-location-closing-hour
                      [labels]="labels"
                      [businessHours]="result.locationOperatingHours"
                    ></app-location-closing-hour>
                  </div>
                </div>
              </div>
              <div
                class="select-location-button"
                (click)="$event.stopPropagation()"
              >
                <!-- #MAWX3276: commenting out directions feature -->
                <!-- <button
                  *ngIf="flow === 'deposit'"
                  class="directions-button"
                  [ngClass]="{ 'flex-basis-50': flow === 'deposit' }"
                  (click)="openBottomSheet(result)"
                >
                  <span class="label">
                    {{ labels.stellar.location.directionsBtnText }}
                  </span>
                </button> -->
                <!-- <button
                  class="location-button"
                  [ngClass]="{ 'flex-basis-50': flow === 'deposit' }"
                  (click)="flow === 'deposit' ? selectLocator(result, i) : openBottomSheet(result)"
                > -->
                <button
                  class="location-button"
                  (click)="selectLocator(result, i)"
                >
                  <span class="label">
                    <!-- {{ flow === 'deposit' ? labels.stellar.signIn.userProfile.select : labels.stellar.location.directionsBtnText }} -->
                    {{
                      locationLabels?.selectLocationBtnTxt
                        .charAt(0)
                        .toUpperCase() +
                        locationLabels?.selectLocationBtnTxt
                          .slice(1)
                          .toLowerCase()
                    }}  
                  </span>
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container 
            *ngIf="isMobileCardExpanded && singleLocationToview"
          >
            <div 
              class="mobile-expand-view"
            >
              <div class="top-bar">
                <img
                  src="assets/images/close-icon.svg"
                  alt="xTimes"
                  (click)="collapseMobileCard()"
                />
                <div class="header">
                  {{
                    sdfCardLabels?.locationMaps?.storeDetails?.storeDetails ||
                      "Store details"
                  }}
                </div>
              </div>
              <div class="map-screen-shot">
                <img *ngIf="mapSnapshotUrl$ | async as mapSnapshotUrl" [src]="mapSnapshotUrl" alt="snapshot" />
              </div>
              <div class="slider-buttons">
                <button class="store"   (click)="switchStoreServiceViw('store')"
                [ngClass]="{ active: isStoreActive }">
                  <span class="store-label"   [ngClass]="{ active: isStoreActive }">
                    {{
                      sdfCardLabels?.locationMaps?.storeDetails?.store ||
                        "Store"
                    }}
                  </span>
                </button>
                <button class="services"   (click)="switchStoreServiceViw('services')"
                [ngClass]="{ active: isServiceActive }">
                  <span class="services-label"   [ngClass]="{ active: isServiceActive }">
                    {{
                      sdfCardLabels?.locationMaps?.storeDetails?.services ||
                        "Services"
                    }}
                  </span>
                </button>
              </div>
              <div class="location-deatils-wrapper">
                <div class="storename-distance">
                  <div class="storename">
                    {{
                      locationFinderService.extractLocationName(
                        singleLocationToview?.locationDetails?.name!
                      )
                    }}
                  </div>
                  <div class="distance">
                    {{ getDistance(singleLocationToview.locationDetails).toLowerCase() }}
                  </div>
                </div>

                <div class="before-you-go-wrapper">
                  <div class="before-header">
                    {{
                      sdfCardLabels?.locationMaps?.storeDetails?.beforeYouGo ||
                        "Before you go..."
                    }}
                  </div>

                  <!-- Comment this out for later future update -->
                  <!-- <div class="dynamic-content">
                    <div class="icon">
                      <img
                        src="assets\images\map-location\image-portriat-icon.svg"
                        alt="portrait"
                      />
                    </div>
                    <div class="content">
                      {{
                        "[Dynamic text] Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                      }}
                    </div>
                  </div> -->
                  <div class="cash-related-content">
                    <div class="icon">
                      <img
                        src="assets\images\map-location\currency-icon.svg"
                        alt="currency"
                      />
                    </div>
                    <div class="content">
                      {{
                        sdfCardLabels?.locationMaps?.storeDetails?.cashOnly ||
                          "You can only use cash for cash-related services at this location."
                      }}
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="store-contact-info">
                    <div class="address-details">
                      <div class="icon">
                        <img
                          src="assets\images\map-location\icon-tag.svg"
                          alt="location-icon"
                        />
                      </div>
                      <div class="address">
                        {{
                          locationFinderService.getFormattedAddress({
                            addressLine1:
                            singleLocationToview?.locationDetails?.addressLine1,
                            addressLine2:
                            singleLocationToview?.locationDetails?.addressLine2,
                            addressLine3:
                            singleLocationToview?.locationDetails?.addressLine3
                          })
                        }},
                        {{
                          locationFinderService.getFormattedAddress({
                            city: singleLocationToview?.locationDetails?.city,
                            state: singleLocationToview?.locationDetails?.state,
                            zipCode: singleLocationToview?.locationDetails?.zipCode,
                            postalCode: singleLocationToview?.locationDetails?.postalCode
                          })
                        }}
                      </div>
                    </div>
                    <div class="contact-details">
                      <div class="icon">
                        <img
                          src="assets\images\map-location\phone.svg"
                          alt="phone"
                        />
                      </div>
                      <div class="contact">
                        {{ singleLocationToview?.locationPhone?.phone }}
                      </div>
                    </div>
                    <div class="store-op">
                      <div class="icon">
                        <img
                          src="assets\images\map-location\clock.svg"
                          alt="clock"
                        />
                      </div>
                      <div class="operations">
                        <app-location-closing-hour
                          [labels]="labels"
                          [businessHours]="singleLocationToview.locationOperatingHours"
                        ></app-location-closing-hour>
                      </div>
                    </div>
                  </div>
                  <div class="divider"></div>

                  <div class="slider-container">
                    <div
                      class="store-slider-content"
                      [@slideStore]="isStoreActive ? 'active' : 'inactive'"
                      (@slideStore.done)="onStoreAnimationDone($event)"
                    >
                      <div class="toggle-lable-icon-container">
                        <div
                          class="label-text"
                          *ngIf="showStoreHours; else hideStoreHours"
                        >
                          {{
                            sdfCardLabels?.locationMaps?.storeDetails
                              ?.showStoreHours || "Show store hours"
                          }}
                        </div>
                        <ng-template #hideStoreHours>
                          <div class="label-text">
                            {{
                              sdfCardLabels?.locationMaps?.storeDetails
                                ?.hideStoreHours || "Hide store hours"
                            }}
                          </div>
                        </ng-template>
                        <div class="icon-wrapper" (click)="toggleHideStoreHours()">
                          <img
                            [ngClass]="
                              !showStoreHours ? 'chevron-up' : 'chevron-down'
                            "
                            src="assets\images\map-location\expand-store-chevron-blue.svg"
                            alt="chevron"
                          />
                        </div>
                      </div>
                      <div 
                        class="store-operations"
                        [@expandCollapse]="showStoreHours ? 'collapsed' : 'expanded'"
                      >
                        <div
                          class="store-hours-details"
                          *ngFor="let day of daysOfWeek; let mobileLocationDetails = index"
                        >
                              <div class="date-hours">
                                <div
                                  class="date"
                                  [ngClass]="{
                                    'current-day-color': todayDay === mobileLocationDetails + 1
                                  }"
                                >
                                  {{ locationLabels[day] }}
                                </div>
                                <div
                                  class="hours"
                                  [ngClass]="{
                                    'current-day-color': todayDay === mobileLocationDetails + 1
                                  }"
                                >
                                  {{ 
                                    isLocationClosedAllDay(result.locationOperatingHours[day]) ? 
                                    locationLabels?.closedTxt || "Closed" : 
                                    result.locationOperatingHours[day] 
                                  }}
                                </div>
                              </div>
                        </div>
                        <div class="specific-hours-wrapper">
                          <div class="specific-hours-content">
                            {{
                              sdfCardLabels?.locationMaps?.storeDetails
                                ?.specificLocationHours ||
                                "Specific hours of operation may vary. Please contact the location for more information."
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="services-slide-content"
                      [@slideService]="isServiceActive ? 'active' : 'inactive'"
                    >
                      <app-location-services
                        [labels]="labels"
                        [locationServices]="singleLocationToview?.locationServices"
                      ></app-location-services>
                    </div>
                  </div>
                </div>
              </div>
              <div class="select-loc-container">
                <!-- #MAWX3276: commenting out directions feature -->
                <!-- <button 
                  type="button" 
                  class="button-select-loc" 
                  (click)="flow === 'deposit' ? selectLocator(singleLocationToview, i) : openBottomSheet(singleLocationToview)"
                > -->
                <button typ="button" class="button-select-loc" (click)="selectLocator(singleLocationToview, i)">
                    <span class="label">
                      <!-- {{ flow === 'deposit' ? locationLabels?.selectLocationBtnTxt : labels.stellar.location.directionsBtnText }} -->
                      {{
                        locationLabels?.selectLocationBtnTxt
                          .charAt(0)
                          .toUpperCase() +
                          locationLabels?.selectLocationBtnTxt
                            .slice(1)
                            .toLowerCase()
                      }}
                    </span>
                  </button>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <ng-container *ngIf="searchResults && searchResults.length > 0">
    <!-- TODO: #mawx3245: #CMS -->
    <button
      class="view-more-btn"
      (click)="handleViewMore()"
      [ngClass]="{ 'hide': isViewMoreBtnHidden || flow === 'deposit' || !isTierFilteringEnabled }"
    >{{ locationLabels?.viewMore || "View More" }}</button>
  </ng-container>
</ng-container>

<!-- #MAWX3276: commenting out directions feature -->
<!-- <ng-container *ngIf="isBottomSheetOpen">
  <div
    [@slideInOutAnimation]="isBottomSheetOpen ? 'in' : 'out'"
    class="directions-bottom-sheet"
  >
    <div class="top-bar">
      <p class="bottom-sheet-title">
        {{ labels.stellar.location.chooseApplication }}
      </p>
      <div class="title-close-container" (click)="closeBottomSheet()">
        <img
          src="assets/images/close-black-icon.svg"
          alt="close-icon"
          class="close-button"
        />
      </div>
    </div>
    <div class="bottom-sheet-content">
      <ul>
        <li (click)="launchDirections(directionsLocation, 'apple')">Maps</li>
        <li (click)="launchDirections(directionsLocation, 'google')">Google Maps</li>
        <li (click)="launchDirections(directionsLocation, 'waze')">Waze</li>
      </ul>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isBottomSheetOpen">
  <div
    [@overlayFadeInOutAnimation]
    (click)="closeBottomSheet()"
    class="overlay"
    [ngClass]="{ active: isBottomSheetOpen }"
  ></div>
</ng-container> -->
